import React, { useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import SleepSlot from "./sleep-slot";
import SleepFile from "./SleepFile";
import Playlist from "./playlist";
import NewSleepFile from "./NewSleepFile"
function Sleep() {
  const [activeTab, setActiveTab] = useState("slot");
  const navigate = useNavigate();

  const getTabClass = (tab) => {
    return `btn ${activeTab === tab ? "btn btn-primary" : "btn btn-secondary"}`;
  };

  return (
    <div className="p-3">
      <div className="d-flex gap-2 mb-4">
        <button
          className={getTabClass("slot")}
          onClick={() => {
            setActiveTab("slot");
            navigate("/sleep");
          }}
        >
          Sleep Slot
        </button>
        <button
          className={getTabClass("Sleep File")}
          onClick={() => {
            setActiveTab("Sleep File");
            navigate("/sleep/file");
          }}
        >
          Sleep File
        </button>
        {/* <button
          className={getTabClass("playlist")}
          onClick={() => {
            setActiveTab("playlist");
            navigate("/radio/playlist");
          }}
        >
          Playlist
        </button> */}
      </div>

      <Routes>
        <Route path="/" element={<SleepSlot />} />
        <Route path="file/new-sleep" element={<NewSleepFile />} />
        {/* <Route path="edit-slot/:slot_id" element={<EditSlot />} /> */}
        {/* <Route path="file/edit-file/:radio_audio_file_id" element={<EditRadioFile />} /> */}
        <Route path="slot-playlist/:id" element={<Playlist />} />
        <Route path="file" element={<SleepFile />} />
      </Routes>
    </div>
  );
}

export default Sleep;
